(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-filter-topics]').each(function () {
		var nav = $(this);
		var links = nav.find('a');
		var posts = $('[data-topic]');

		if (links.length && posts.length) {

			// Filter posts by ID
			var filterPosts = function (id) {
				var activeTopic = links.filter('[href="#' + id + '"]');
				var activePosts = posts.filter('[data-topic="' + id + '"]');

				links.parent().removeClass('current-cat');
				activeTopic.parent().addClass('current-cat');

				posts.addClass('hidden');

				if (activePosts.length) {
					activePosts.removeClass('hidden');
				}

				if (id == 'all') {
					posts.removeClass('hidden');
				}
			};

			// Open tabs on link click
			links.on('click', function (e) {
				e.preventDefault();
				filterPosts($(this).attr('href').substr(1));
			});

			// Set first to current
			filterPosts(links.eq(0).attr('href').substr(1));
		}
	});
})();
